export default __webpack_public_path__ + "static/about-block-4-6a7697269f88599b28f74a2f0bff1c15.jpg";